import React from "react";
import { Modal } from "react-bootstrap";
import { AttachmentIcon } from "../CustomFunctions";


const getStatusClass = (status) => {
    switch ((status || "").toLowerCase()) {
        case "pending": return "color-badge-warning";
        case "approved": return "color-badge-success";
        case "rejected": return "color-badge-danger";
        default: return "";
    }
};

const AttachmentLink = ({ proof }) => {
    if (!proof) {
        return <span className="">- No File Attached -</span>;
    }
    if (proof?.document) {
        return (
            <a
                href={proof.document}
                target="_blank"
                rel="noreferrer"
                className="doc-link"
            >
                <AttachmentIcon source={proof.document} />
                <span className="ms-1">View Document</span>
            </a>
        );
    }

    if (proof.document_url) {
        return (
            <a
                href={proof.document_url}
                target="_blank"
                rel="noreferrer"
                className="doc-link"
            >
                <AttachmentIcon source={proof.document_url} />
                <span className="ms-1">{proof.document_url}</span>
            </a>
        );
    }

    return <span className="text-muted">- No File Attached -</span>;
};

const ProofViewModal = ({ show, onClose, proofs = [], calculationProofsData }) => {


    const hasAnyValue = (obj) => {
        if (!obj) return false;

        return Object.values(obj).some(
            val =>
                val !== null &&
                val !== undefined &&
                val !== "" &&
                !(Array.isArray(val) && val.length === 0)
        );
    };


    return (
        <Modal show={show} onHide={onClose} dialogClassName="half-modal">
            <Modal.Header closeButton>
                <Modal.Title>
                    Item Details
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <h4>Proof Details</h4>
                {proofs?.length > 0 ? (
                    <>{
                        proofs.map((proof, idx) => (
                            <>

                                <div
                                    key={idx}
                                    className="proof-card"
                                    style={{
                                        background: "#fff",
                                        borderRadius: 10,
                                        padding: "18px 20px",
                                        marginBottom: 16,
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                        border: "1px solid #e5e7eb",
                                    }}
                                >
                                    <div className="flex flex-row align-center" style={{
                                        borderBottom: "1px solid #eee",
                                        paddingBottom: 10,
                                        marginBottom: 12,
                                        fontSize: 16,
                                        fontWeight: 600,
                                        paddingLeft: '0px',
                                        gap: '10px',
                                        justifyContent: 'start'
                                    }}>
                                        <div

                                        >
                                            Section:{" "}
                                        </div>
                                        <span>{proof?.items_details?.section_name || "-"}</span>
                                    </div>


                                    <div className="detail-list">

                                        <div className="detail-row">
                                            <span className="detail-view-label">Document:</span>
                                            <span className="detail-view-value"><AttachmentLink proof={proof} /></span>
                                        </div>

                                        <div className="detail-row">
                                            <span className="detail-view-label">Proof Amount:</span>
                                            <span className="detail-view-value">
                                                {proof.proof_amt ? Number(proof.proof_amt).toLocaleString() : "-"}
                                            </span>
                                        </div>

                                        <div className="detail-row">
                                            <span className="detail-view-label">Remarks:</span>
                                            <span className="detail-view-value">{proof.remarks || "-"}</span>
                                        </div>

                                        <div className="detail-row">
                                            <span className="detail-view-label">Status:</span>
                                            <span className="detail-view-value">
                                                <span className={`status-badge ${getStatusClass(proof.status)}`}>
                                                    {proof.status || "-"}
                                                </span>
                                            </span>
                                        </div>

                                    </div>

                                </div>
                            </>
                        ))}

                    </>
                ) : (
                    <p>No proof details available.</p>
                )}

                {/* ----calculation detail */}
                {hasAnyValue(calculationProofsData) && (
                    <>
                        <hr className="line" />


                        <div
                            className="proof-card"
                            style={{
                                // background: "#fff",
                                // borderRadius: 10,
                                padding: "18px 20px",
                                // marginBottom: 16,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                border: "1px solid #e5e7eb",
                            }}
                        >
                            <div className="detail-list">

                                <div className="detail-row">
                                    <span className="detail-view-label">Calculation Attachment:</span>
                                    <span className="detail-view-value">
                                        <AttachmentLink proof={calculationProofsData.calculation_attachment} />
                                    </span>
                                </div>

                                <div className="detail-row">
                                    <span className="detail-view-label">Calculation Amount:</span>
                                    <span className="detail-view-value">
                                        {calculationProofsData.calculation_amount
                                            ? Number(calculationProofsData.calculation_amount).toLocaleString()
                                            : "-"}
                                    </span>
                                </div>

                                <div className="detail-row">
                                    <span className="detail-view-label">Calculation Remarks:</span>
                                    <span className="detail-view-value">
                                        {calculationProofsData.calculation_remarks || "-"}
                                    </span>
                                </div>

                            </div>
                        </div>
                    </>
                )}

            </Modal.Body>
        </Modal>
    );
};

export default ProofViewModal;
